import configStorage from '../../configuration/config-storage';
import { t } from '../../localization';
import getDomainPrices from './get-domain-prices';
import formatPrice from './format-price';

const COM_DOMAIN = 'com';

function processDomainsData({
  prices,
  domains,
  currency,
  extraPrice,
  isSpecialOfferAvailable,
  isTrialDiscountAvailable,
  isMdBreakpoint,
  withFreeSubdomain,
}) {
  if (!domains) {
    return null;
  }

  const { locale = 'en' } = configStorage.get();

  return domains.map((domainItem, index) => {
    const defaultCaptions = {
      title: domainItem.domain,
      price: t('Taken'),
    };

    const tld = domainItem.domain.split('.').slice(1).join('.');
    const priceData = prices && prices[tld];

    if (!domainItem.available || !priceData) {
      return {
        domain: domainItem.domain,
        captions: defaultCaptions,
        disabled: true,
        priceAppearance: 'low-emphasis',
      };
    }

    const { price, oldPrice } = getDomainPrices({
      priceData,
      currency,
      extraPrice,
      isSpecialOfferAvailable,
    });

    const formattedPrice = formatPrice(price, currency, locale);
    const label = index === 0 && tld === COM_DOMAIN && withFreeSubdomain ? t('Recommended') : null;
    const popoverContent = isTrialDiscountAvailable
      ? t('Get a domain discount for 1 year')
      : t(
          'Get a free domain for 1 year. Offer valid for the following extensions: .com, .uk, .co.uk, .us, .it, .biz, .de, .nl, .eu, .in, .co.za, .club, .info, .work, .xyz'
        );

    return {
      captions: {
        title: domainItem.domain,
        label,
        button: isMdBreakpoint ? t('Select') : formattedPrice,
        ...(isMdBreakpoint && { price: formatPrice(price, currency, locale) }),
        ...(isSpecialOfferAvailable && {
          oldPrice: formatPrice(oldPrice, currency, locale),
          popoverContent,
          ...(isMdBreakpoint && { priceDescription: t('with annual plan') }),
        }),
      },
      ...(isSpecialOfferAvailable && { priceAppearance: 'success' }),
      ...domainItem,
    };
  });
}

export default processDomainsData;
